// extracted by mini-css-extract-plugin
module.exports = {"footer":"ResultsFooter_footer__22t6_","footerItem":"ResultsFooter_footerItem__3unVJ","missingList":"ResultsFooter_missingList__1CAv7"};